import {GraphValues} from "./GraphValues";

export class PiattoBiInformazioni {
    frequenzaOrdinazione!: GraphValues[];
    aggiunteRichieste!: GraphValues[];
    rimozioniRichieste!: GraphValues[];

    static fromJson(json: any): PiattoBiInformazioni {
        let result = new PiattoBiInformazioni();
        result.frequenzaOrdinazione = json.frequenzaOrdinazione?.map((value: any) => GraphValues.fromJson(value)) || [];
        result.aggiunteRichieste = json.aggiunteRichieste?.map((value: any) => GraphValues.fromJson(value)) || [];
        result.rimozioniRichieste = json.rimozioniRichieste?.map((value: any) => GraphValues.fromJson(value)) || [];
        return result;
    }
}